module.exports = __webpack_public_path__ + "static/media/shopping-cart-gray.03646e41.svg";